import { render, staticRenderFns } from "./ViewInvoices.vue?vue&type=template&id=970768b8&scoped=true&"
import script from "./ViewInvoices.vue?vue&type=script&lang=js&"
export * from "./ViewInvoices.vue?vue&type=script&lang=js&"
import style0 from "./ViewInvoices.vue?vue&type=style&index=0&id=970768b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970768b8",
  null
  
)

export default component.exports